import BottomMobileOptionsModal from "@/components/bottom-mobile-options-modal";
import { Button } from "@/components/ui/button";
import type { Dialog } from "@/components/ui/dialog";

interface UnfollowModalProps extends React.ComponentProps<typeof Dialog> {
  onUnfollow(): void;
  username: string;
}

export default function UnfollowModal({
  onUnfollow,
  username,
  ...props
}: UnfollowModalProps) {
  const handleUnfollow = () => {
    onUnfollow();
    props.onOpenChange?.(false);
  };

  return (
    <BottomMobileOptionsModal title={`Unfollow ${username}?`} {...props}>
      <ul className="flex flex-col items-stretch gap-2.5">
        <li>
          <Button onClick={handleUnfollow} variant="bottomMenuItem">
            Yes, unfollow
          </Button>
        </li>
        <li>
          <Button
            onClick={() => props.onOpenChange?.(false)}
            variant="bottomMenuItem"
          >
            Cancel
          </Button>
        </li>
      </ul>
    </BottomMobileOptionsModal>
  );
}
